import type {IFetchContext} from "@pg-mono/data-fetcher";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import type {IRPStore} from "../../app/rp_reducer";
import type {IRPRequestMeta} from "../../app/rp_request_meta";
import {type MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {defaultMetaData} from "../../meta_data/reducers/meta_data_reducer";

const ogImage = rpCommonUrl + require("../images/og_image.png");

export const updateHomepageMetaData = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch, _getState: () => IRPStore) => {
    dispatch(
        updateMetaData({
            title: defaultMetaData.title,
            description: defaultMetaData.description,
            pathname: ctx.route.pathname,
            ogImage
        })
    );

    return true;
};
import type {IFetchContext} from "@pg-mono/data-fetcher";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import type {IRPStore} from "../../app/rp_reducer";
import type {IRPRequestMeta} from "../../app/rp_request_meta";
import {type MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {defaultMetaData} from "../../meta_data/reducers/meta_data_reducer";

const ogImage = rpCommonUrl + require("../images/og_image.png");

export const updateHomepageMetaData = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch, _getState: () => IRPStore) => {
    dispatch(
        updateMetaData({
            title: defaultMetaData.title,
            description: defaultMetaData.description,
            pathname: ctx.route.pathname,
            ogImage
        })
    );

    return true;
};
